const PrimeReactConstants = {
  BOTTOM: "bottom",
  CENTER: "center",
  CONTAINS: "contains",
  FLEX: "flex",
  LARGE: "large",
  LEFT: "left",
  MESSAGE_SEVERITY: {
    DANGER: "danger",
    ERROR: "error",
    INFO: "info",
    SUCCESS: "success",
    WARN: "warn",
  },
  MULTIPLE: "multiple",
  NUMERIC: "numeric",
  PAGINATOR: {
    TEMPLATE: {
      layout:
        "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink",
    },
  },
  RANGE: "range",
  RIGHT: "right",
  ROW: "row",
  SMALL: "small",
  TOP: "top",
};

export default PrimeReactConstants;
